<template>
	<div>
		<container-edit-modal
				v-if="spawnCreateModal"
				v-model="showCreateModal"
				:is-new-line-item="true"
				:job-id="record.fieldData['__PKJobID']"
				@container-created="onContainerCreated"
		></container-edit-modal>
		<y-b-container-edit-modal
				v-if="spawnYbCreateModal"
				v-model="showYbCreateModal"
				:is-new-line-item="true"
				:job-id="record.fieldData['__PKJobID']"
				@container-created="onYbContainerCreated"
		></y-b-container-edit-modal>
		<b-modal v-model="showExportModal" ok-title="Close" ok-only>
			<div class="text-center">
				<a v-if="exportModalFileType === 'xlsx'" :href="exportModalUrl" target="_blank"
										:download="exportModalFileName">Download File</a>
				<a v-else :href="exportModalUrl" target="_blank" :download="exportModalFileName">Download File</a>
			</div>
		</b-modal>
		<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showMoveModal" v-if="showMoveModal"
					 @hidden="closeMoveModal()" @ok="moveToYB(recordToMove)" width="600">
			<template #modal-title><h5>Move To Yellow Bucket</h5></template>
			<span>
					<div>Are you sure you want to move container <span
							style="font-weight:bold;">{{ recordToMove["Containers::Container_PK_ID"] }}</span>? This action will delete the original container permanently.</div>
				</span>
		</b-modal>
		<div class="row">
			<ul class="col-12 nav justify-content-end">
				<li class="nav-item">
					<b-dropdown text="Export to Excel" variant="link">
						<b-dropdown-item :disabled="!hasContainers" @click.prevent="exportToExcel(false)">Standard
							Container
						</b-dropdown-item>
						<b-dropdown-item :disabled="!hasYellowBuckets" @click.prevent="exportToExcel(true)">Yellow
							Bucket Container
						</b-dropdown-item>
					</b-dropdown>
				</li>
				<li class="nav-item">
					<b-dropdown text="Save as PDF" variant="link" right>
						<b-dropdown-item :disabled="!hasContainers" @click.prevent="saveAsPdf(false)">Standard
							Container
						</b-dropdown-item>
						<b-dropdown-item :disabled="!hasYellowBuckets" @click.prevent="saveAsPdf(true)">Yellow Bucket
							Container
						</b-dropdown-item>
					</b-dropdown>
				</li>
			</ul>
		</div>
		<div id="job" class="card pb-3">
			<vue-headful
					:title="title">
			</vue-headful>
			<b-modal
					v-model="showPicModal"
					:title="'Pictures: ' + record.fieldData.__PKJobID + ' - ' + record.fieldData['Job Name']"
					class-name="my-modal-wrap"
					:footer-hide="hideFooter"
					size="xl"
					:ok-only="true"
					ok-title="Close"
			>
				<b-tabs ref="picTab">
					<b-tab title="Reconciliation" active>
						<b-carousel id="carousel1"
									style="text-shadow: 1px 1px 2px #333;"
									controls
									indicators
									background="#000000"
									:interval="interval"
									v-model="recSlide"
									@sliding-start="checkImage"
									ref="recCarousel"
						>
							<b-carousel-slide v-for="pic in reconciliationPics" class="pic-slide">
								<b-img slot="img" :src="getImageUrl(pic)" :center="true"/>
							</b-carousel-slide>
						</b-carousel>
					</b-tab>
					<b-tab title="Pick-Up">
						<b-carousel id="carousel2"
									style="text-shadow: 1px 1px 2px #333;"
									controls
									indicators
									background="#000000"
									:interval="interval"
									v-model="pickSlide"
						>
							<b-carousel-slide v-for="pic in pickupPics" class="pic-slide">
								<b-img slot="img" :src="getImageUrl(pic)" :center="true"/>
							</b-carousel-slide>
						</b-carousel>
					</b-tab>
					<b-tab title="Transportation">
						<b-carousel id="carousel3"
									style="text-shadow: 1px 1px 2px #333;"
									controls
									indicators
									background="#000000"
									:interval="interval"
									v-model="tranSlide"
						>
							<b-carousel-slide v-for="pic in transportationPics" class="pic-slide">
								<b-img slot="img" :src="getImageUrl(pic)" :center="true"/>
							</b-carousel-slide>
						</b-carousel>
					</b-tab>
					<b-tab title="Destruction">
						<b-carousel id="carousel4"
									style="text-shadow: 1px 1px 2px #333;"
									controls
									indicators
									background="#000000"
									:interval="interval"
									v-model="destSlide"
						>
							<b-carousel-slide v-for="pic in destructionPics" class="pic-slide">
								<b-img slot="img" :src="getImageUrl(pic)" :center="true"/>
							</b-carousel-slide>
						</b-carousel>
					</b-tab>
<!--					<b-tab title="Driver">
						<b-carousel id="carousel5"
									style="text-shadow: 1px 1px 2px #333;"
									controls
									indicators
									background="#000000"
									:interval="interval"
									v-model="driveSlide"
						>
							<b-carousel-slide v-for="pic in driverPics" class="pic-slide">
								<img slot="img" :src="pic"/>
							</b-carousel-slide>
						</b-carousel>
					</b-tab>-->
				</b-tabs>
			</b-modal>
			<div class="card-body">
				<div class="card-title">
					<div class="row">
						<h5 class="col-6">
							<div class="row">
								<div class="col-12">
									<font-awesome-icon style="margin-right: 0.5em;"
													   v-if="locked"
													   icon="lock"></font-awesome-icon>
									<strong>Job {{ record.fieldData['__PKJobID'] }}</strong>
                  <button
                    v-if="showJobReadyButton"
                    @click="sendJobReadyNotification()"
                    class="btn btn-primary ml-md-3"
                  >
                    Job Ready
                    <font-awesome-icon style="margin-right: 0.5em;"
                                       icon="envelope" class="ml-2"></font-awesome-icon>
                  </button>

								</div>

<!--								<div class="col-6 text-right" v-if="editable">
									<a href="#" @click.prevent="toggleEditMode()">
										Cancel
										<font-awesome-icon icon="times"></font-awesome-icon>
									</a>
								</div>-->
							</div>
						</h5>
						<h5 class="col-6">
							<div class="float-right"><strong>Job Name {{ record.fieldData['Job Name'] }}</strong></div>
						</h5>
					</div>
					<div v-show="locked" class="row">
						<ul class="nav col-12 justify-content-end">
							<li class="nav-item mr-3">
								<a
										href=""
										@click.prevent="viewPicModal"
								>
									Pictures
									<font-awesome-icon class="ml-1" icon="images"></font-awesome-icon>
								</a>
							</li>
							<li v-show="record.fieldData['CWF Files']" class="nav-item mr-3">
								<a target="_blank" :href="record.fieldData['CWF Files']">CWF
									<font-awesome-icon class="ml-1" icon="file-alt"></font-awesome-icon>
								</a>
							</li>
							<li v-show="record.fieldData['41 Insert']" class="nav-item mr-3">
								<a target="_blank" :href="record.fieldData['41 Insert']">41
									<font-awesome-icon class="ml-1" icon="file-alt"></font-awesome-icon>
								</a>
							</li>
							<li v-show="record.fieldData['Shipping Files']" class="nav-item mr-3">
								<a target="_blank" :href="record.fieldData['Shipping Files']">Shipping
									<font-awesome-icon class="ml-1" icon="file-alt"></font-awesome-icon>
								</a>
							</li>
							<li v-show="record.fieldData['Supporting Files']" class="nav-item mr-3">
								<a target="_blank" :href="record.fieldData['Supporting Files']" class="disabled">Supporting
									<font-awesome-icon class="ml-1" icon="file-alt"></font-awesome-icon>
								</a>
							</li>
              <li v-show="record.fieldData['Digital 222 Files']" class="nav-item">
                <a target="_blank" :href="record.fieldData['Digital 222 Files']" class="disabled">Digital 222
                  <font-awesome-icon class="ml-1" icon="file-alt"></font-awesome-icon>
                </a>
              </li>
						</ul>
					</div>
				</div>
				<FeedbackPanel/>
				<div class="row">
					<router-view
							@set-edit-mode="setEditMode"
							:record="record"
							:record-id="recordId"
							:locked="locked"
							:entity="'job'"
							@update-record="updateRecord"
					></router-view>
					<div class="col-lg-8 col-sm-12">
						<b-card no-body>
							<b-tabs card>
								<b-tab
										title="Containers"
								>
									<div class="pt-2 pb-1">
										<label class="small" style="display: inline-block;">
											Show
										</label>
										<b-form-select
												v-model="contRowsPerPage"
												:options="rowsPerPageOptions"
												size="sm"
												style="width: auto; display: inline-block;"
												class="mr-2 ml-2"
												plain
										></b-form-select>
										<label class="small" style="display: inline-block;">
											entries
										</label>
										<div v-if="!locked && accessPrivileges.includes('CREATE_CONTAINER')" class="float-right">
											<a href="#" @click.prevent="displayEditModal">
												Container
												<font-awesome-icon icon="plus-circle"></font-awesome-icon>
											</a>
										</div>
									</div>
									<b-table
											:fields="containerTableFields"
											:items="record.portalData.Containers"
											:per-page="contRowsPerPage"
											:current-page="contPage"
											primary-key="Containers::Container_PK_ID"
											small
											responsive
											hover
											id="container-table"
									>
										<template v-slot:head(locked)="data">
											<span style="margin-right: 0.25em;">
												<font-awesome-icon icon="lock"></font-awesome-icon>
											</span>
										</template>
										<template v-slot:cell(locked)="data">
											<span style="margin-right: 0.25em;">
												<span v-if="data.item['Containers::Locked Container'] === 'Yes'"><font-awesome-icon
														icon="lock"></font-awesome-icon></span>
											</span>
										</template>
										<template v-slot:cell(view)="data">
											<router-link
													:to="{name: 'container-view', params: {id: data.item.recordId}}">
												<font-awesome-icon icon="eye"></font-awesome-icon>
											</router-link>
										</template>
<!--										<template v-slot:cell(move)="data" style="width: 28px;">
											<a v-if="accessPrivileges.includes('CREATE_CONTAINER') && !locked && 'Yes' !== data.item['Containers::Locked Container']"
											   title="Move To Yellow Bucket" @click="displayMoveModal(data.item)">
												<svg style="color: #ffd700;" class="svg-inline&#45;&#45;fa fa-w-16"
													 version="1.1"
													 viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
													<path fill="currentColor"
														  d="m96.875 18.75h-4.0039c-4.0508-7.1328-21.707-12.5-42.871-12.5-21.168 0-38.82 5.3672-42.871 12.5h-4.0039c-1.7266 0-3.125 1.3984-3.125 3.125s1.3984 3.125 3.125 3.125h3.125l12.5 56.25c0 6.9023 13.988 12.5 31.25 12.5 17.258 0 31.25-5.5977 31.25-12.5l12.5-56.25h3.125c1.7266 0 3.125-1.3984 3.125-3.125s-1.3984-3.125-3.125-3.125zm-46.875 12.5c-17.262 0-31.25-4.1992-31.25-9.375s13.988-9.375 31.25-9.375c17.258 0 31.25 4.1992 31.25 9.375s-13.992 9.375-31.25 9.375z"
														  fill-rule="evenodd"/>
												</svg>
											</a>
										</template>-->
									</b-table>
									<div v-if="contMaxRows > 0"
										 style="font-size: smaller; float: left; top: 0.5em; position: relative;">
										Showing
										{{
											contMaxRows === 0 ? 0 : contRowsPerPage
											* (contPage - 1) + 1
										}} to {{
											Math.min(contRowsPerPage * contPage,
													contMaxRows)
										}} of
										{{ contMaxRows }} entries
									</div>
									<b-pagination
											size="sm"
											:total-rows="contMaxRows"
											:per-page="contRowsPerPage"
											v-model="contPage"
											align="right"
									></b-pagination>
									<div style="font-size: smaller;">{{record.fieldData['CN_LI::Found Count']}} Total Line Items</div>
								</b-tab>
								<b-tab
										title="Yellow Bucket Containers"
								>
									<div class="pt-2 pb-1">
										<label class="small" style="display: inline-block;">
											Show
										</label>
										<b-form-select
												v-model="ybRowsPerPage"
												:options="rowsPerPageOptions"
												size="sm"
												style="width: auto; display: inline-block;"
												class="mr-2 ml-2"
												plain
										></b-form-select>
										<label class="small" style="display: inline-block;">
											entries
										</label>
										<div v-if="!locked && accessPrivileges.includes('CREATE_CONTAINER')" class="float-right">
											<a href="#" @click.prevent="displayYbEditModal">
												Yellow Bucket
												<font-awesome-icon icon="plus-circle"></font-awesome-icon>
											</a>
										</div>
									</div>
									<b-table
											id="yb-table"
											:fields="ybTableFields"
											:items="record.portalData.YellowBuckets"
											:per-page="ybRowsPerPage"
											:current-page="ybPage"
											primary-key="hcn.holding_cn::Container ID"
											small
											responsive
											hover
									>
										<template v-slot:head(locked)="data">
											<span style="margin-right: 0.25em;">
												<font-awesome-icon icon="lock"></font-awesome-icon>
											</span>
										</template>
										<template v-slot:cell(locked)="data">
											<span style="margin-right: 0.25em;">
												<span v-if="data.item['hcn.holding_cn::Locked Container'] === 'Yes'"><font-awesome-icon
														icon="lock"></font-awesome-icon></span>
											</span>
										</template>
										<template v-slot:cell(view)="data" style="width: 28px;">
											<router-link
													:to="{name: 'yb-container-view', params: {id: data.item.recordId}}">
												<font-awesome-icon icon="eye"></font-awesome-icon>
											</router-link>
										</template>
									</b-table>
									<div v-if="ybMaxRows > 0"
										 style="font-size: smaller; float: left; top: 0.5em; position: relative;">
										Showing
										{{
											ybMaxRows === 0 ? 0 : ybRowsPerPage
											* (ybPage - 1) + 1
										}} to {{
											Math.min(ybRowsPerPage * ybPage,
													ybMaxRows)
										}} of
										{{ ybMaxRows }} entries
									</div>
									<b-pagination
											size="sm"
											:total-rows="ybMaxRows"
											:per-page="ybRowsPerPage"
											v-model="ybPage"
											align="right"
									></b-pagination>
									<div style="font-size: smaller;">{{record.fieldData[
											'hcn.holding_li_SHOWCN::Found_Count']}} Total Line Items</div>
								</b-tab>
							</b-tabs>
						</b-card>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import feedbackMixin from '../mixins/feedback'
import detailViewMixin from '../mixins/detail-view'
import PortalGrid from '../components/PortalGrid'
import FeedbackPanel from '../components/FeedbackPanel';
import DatePicker from '../components/DatePicker'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import exportFileMixin from "../mixins/export-file";
import CustomModal from "../components/Modal";
import Container from "@/views/Container";
import ContainerEditModal from "@/components/ContainerEditModal";
import YBContainerEditModal from "@/components/YBContainerEditModal";
import ToastedPlugin from "vue-toasted";

Vue.use(VueAxios, axios);
Vue.use(ToastedPlugin, {
  duration: 5000
});

export default {
	name: "Job",
	mixins: [feedbackMixin, detailViewMixin, exportFileMixin],
	components: {YBContainerEditModal, ContainerEditModal, Container, DatePicker, FeedbackPanel, PortalGrid, CustomModal},
	methods: {
		getImageUrl(imageUrl) {
			let fullUrl = imageUrl;
			return fullUrl
		},
		displayEditModal() {
			this.showCreateModal = true
			this.spawnCreateModal = true
		},
		displayYbEditModal() {
			this.showYbCreateModal = true
			this.spawnYbCreateModal = true
		},
		onContainerCreated(event) {
			this.$router.push({
				name: 'container-view',
				params: {
					id: event.recordId
				}
			})
			this.showCreateModal = false
			this.spawnCreateModal = false
		},
		onYbContainerCreated(event) {
			this.$router.push({
				name: 'yb-container-view',
				params: {
					id: event.recordId
				}
			})
			this.showYbCreateModal = false
			this.spawnYbCreateModal = false
		},
		displayMoveModal: function (record) {
			this.recordToMove = record;
			this.showMoveModal = true;
			this.deleteSourceRecord = false
		},
		closeMoveModal: function () {
			this.recordToMove = null;
			this.showMoveModal = false;
			this.deleteSourceRecord = false
		},
		exportToExcel: function (isYellow = false) {
			let scriptName = '3DS_Excel_Export_On_Server';
			let fileName = 'export.xlsx';
			let quickFind = false;
			let searchCriteria = isYellow ? [{"Job::__PKJobID": '==' + this.record.fieldData['__PKJobID']}] : [{id_job: '==' + this.record.fieldData['__PKJobID']}];
			let restEntity = isYellow ? 'yb-line-items' : 'line-items';
			this.exportFile(searchCriteria, quickFind, restEntity, 'xlsx')
		},
		saveAsPdf: function (isYellow = false) {
			let scriptName = '3DS_PDF_Save_On_Server';
			let fileName = 'export.pdf';
			let quickFind = false;
			let searchCriteria = isYellow ? [{"Job::__PKJobID": '==' + this.record.fieldData['__PKJobID']}] : [{id_job: '==' + this.record.fieldData['__PKJobID']}];
			let restEntity = isYellow ? 'yb-line-items' : 'line-items';
			this.exportFile(searchCriteria, quickFind, restEntity)
		},
		goToPage: function (event) {
			if (event) {
				this.contPage = event.page
			}
		},
		updateRowsPerPage: function (event) {
			if (event) {
				this.contRowsPerPage = event.limit;
				this.goToPage(event)
			}
		},
		addContainer: function () {
			Vue.axios.post('/3ds/api/container',
				{
					fieldData: {
						"Job ID": this.record.fieldData['__PKJobID']
					},

				},
				{
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
				.then(value => {
					this.$router.push({
						name: 'container-edit',
						params: {
							id: value.data.recordId
						},
						query: {
							new: true
						}
					})
				})
				.catch(reason => {
					this.authCheck(reason)
				})
		},
		addYbContainer: function () {
			Vue.axios.post('/3ds/api/yb-container',
				{
					fieldData: {
						"Job ID": this.record.fieldData['__PKJobID']
					},

				},
				{
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
				.then(value => {
					this.$router.push({
						name: 'yb-container-edit',
						params: {
							id: value.data.recordId
						}
					})
				})
				.catch(reason => {
					this.authCheck(reason)
				})
		},
		viewPicModal: function () {
			if (this.$refs.picTab && this.$refs.picTab.currentTab === 0) {
				Vue.axios.head(this.reconciliationPics[this.recSlide])
					.then(value => {

					})
					.catch(reason => {
						this.showBlankImages = true
					})
			}
			this.showPicModal = true
		},
		checkImage: function (slide) {
			console.log('Checking image before slide');
			console.log(JSON.stringify(slide))
		},
		moveToYB: function (record) {
			console.log(`Move container ${record.recordId} to YB`);
			if (!this.locked && 'Yes' !== record['Containers::Locked Container']) {
				let body = {
					containerId: record['Containers::Container_PK_ID'],
				}
				let that = this;
				this.axios.post('/3ds/api/job/move-container-to-yb/' + this.recordId, body, {
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				})
					.then(value => {
						let scriptResult = JSON.parse(value.data.scriptResult);
						if (scriptResult.succeeded) {
							console.log(JSON.stringify(value));
							that.record.portalData.Containers = value.data.data[0].portalData.Containers;
							that.record.portalData.YellowBuckets = value.data.data[0].portalData.YellowBuckets
						} else {
							that.push_error({
								message: 'An error occurred while attempting to move a container to a yellow bucket',
								type: 'DANGER',
							})
						}
					})
					.catch(reason => {
						this.closeMoveModal();
						this.pushError({
							message: 'An error occurred while attempting to move a container to a yellow bucket',
							type: 'DANGER'
						});
						console.error(JSON.stringify(reason))
					})
					.finally(() => {
						this.closeMoveModal()
					})
			}
		},
    sendJobReadyNotification: function () {
      console.log(`Begin sendJobReadyNotification`);
      this.axios.post(`/3ds/api/sendJobReadyNotification`, this.record.fieldData, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
      })
          .then(value => {
            this.$toasted.show("A notification has been sent that your job is ready", {
              type: 'success',
            })
            console.log('Notification successfully sent')
          })
          .catch(reason => {
            console.error('Notification failed')
            console.error(JSON.stringify(reason))
            this.$toasted.show("Notification Could Not Be Sent", {
              type: 'error',
            })
          })
      }
	},
	computed: {
		hasContainers: function () {
			return this.record.portalData.Containers && this.record.portalData.Containers.length > 0;
		},
		hasYellowBuckets: function () {
			return this.record.portalData.YellowBuckets && this.record.portalData.YellowBuckets.length > 0;
		},
		locked: function () {
			return this.record.fieldData['Locked Job'] && this.record.fieldData['Locked Job'].toUpperCase() === 'YES'
		},
		showJobReadyButton: function () {
			return !!this.record.fieldData['__PKJobID'] && !this.locked
		},
		ybMaxRows: function () {
			if (this.record.portalData.YellowBuckets) {
				let length = this.record.portalData.YellowBuckets.length;
				console.log('Max rows ' + length);
				return length
			} else {
				return 50
			}
		},
		contMaxRows: function () {
			if (this.record.portalData.Containers) {
				let length = this.record.portalData.Containers.length;
				console.log('Max rows ' + length);
				return length
			} else {
				return 50
			}
		},
		reconciliationPics: function () {
			let returnValue = [];
			for (let i = 1; i <= 9; i++) {
				let recVal =  (this.record.fieldData['Sister Jobs'] && this.record.fieldData['Sister Jobs'].length > 0) ? this.record.fieldData['SisterJob::R' + i.toString()] : this.record.fieldData['R' + i.toString()];
				if (recVal) {
					returnValue.push(recVal)
				}
			}
			return returnValue
		},
		pickupPics: function () {
			let returnValue = [];
			for (let i = 1; i <= 12; i++) {
				let recVal =  (this.record.fieldData['Sister Jobs'] && this.record.fieldData['Sister Jobs'].length > 0) ? this.record.fieldData['SisterJob::P' + i.toString()] : this.record.fieldData['P' + i.toString()];
				if (recVal) {
					returnValue.push(recVal)
				}
			}
			return returnValue
		},
		transportationPics: function () {
			let returnValue = [];
			for (let i = 1; i <= 12; i++) {
				let recVal =  (this.record.fieldData['Sister Jobs'] && this.record.fieldData['Sister Jobs'].length > 0) ? this.record.fieldData['SisterJob::T' + i.toString()] : this.record.fieldData['T' + i.toString()];
				if (recVal) {
					returnValue.push(recVal)
				}
			}
			return returnValue
		},
		destructionPics: function () {
			let returnValue = [];
			for (let i = 1; i <= 21; i++) {
				let recVal =  (this.record.fieldData['Sister Jobs'] && this.record.fieldData['Sister Jobs'].length > 0) ? this.record.fieldData['SisterJob::D' + i.toString()] : this.record.fieldData['D' + i.toString()];
				if (recVal) {
					returnValue.push(recVal)
				}
			}
			return returnValue
		},
		driverPics: function () {
			let returnValue = [];
			for (let i = 1; i <= 7; i++) {
				let recVal =  (this.record.fieldData['Sister Jobs'] && this.record.fieldData['Sister Jobs'].length > 0) ? this.record.fieldData['SisterJob::DP' + i.toString()] : this.record.fieldData['DP' + i.toString()];
				if (recVal) {
					returnValue.push(recVal)
				}
			}
			return returnValue
		},
		title: function () {
			return this.record.fieldData['Job Name']
		}
	},
	data() {
		return {
			showCreateModal: false,
			spawnCreateModal: false,
			showYbCreateModal: false,
			spawnYbCreateModal: false,
			deleteSourceRecord: false,
			recordToMove: null,
			showMoveModal: false,
			tranSlide: 0,
			pickSlide: 0,
			recSlide: 0,
			destSlide: 0,
			driveSlide: 0,
			interval: 0,
			showBlankImages: false,
			showPicModal: false,
			showFileModal: false,
			hideFooter: true,
			restEntity: 'job',
			restViewEntity: 'job-view',
			portals: [
				{
					name: 'Containers',
					limit: 500,
				},
				{
					name: 'YellowBuckets',
					limit: 500,
				}
			],
			contPortalName: 'Containers',
			contTitle: 'Containers',
			contRestDetailEntity: 'container-view',
			contFooter: true,
			contHeader: true,
			contCardHeader: false,
			contPage: 1,
			contRowsPerPage: 25,
			ybFooter: true,
			ybHeader: true,
			ybCardHeader: false,
			ybPage: 1,
			ybRowsPerPage: 25,
			ybTableFields: [
				{
					key: 'locked',
					label: '',
					sortable: true,
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'view',
					label: ' ',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'hcn.holding_cn::Container ID',
					label: 'ID',
					sortable: true
				},
				{
					key: 'hcn.holding_cn::Container Name',
					label: 'Name',
					sortable: true
				},
				{
					key: 'hcn.holding_cn::Container Type',
					label: 'Type',
					sortable: true
				},
				{
					key: 'hcn.holding_cn::Pallet',
					label: 'Pallet',
					sortable: true
				},
				{
					key: 'hcn.holding_cn::Line_Item_Count',
					label: 'LI Ct',
					sortable: true
				}
			],
			containerTableFields: [
				{
					key: 'locked',
					label: '',
					sortable: true,
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'view',
					label: ' ',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'Containers::Container_PK_ID',
					label: 'ID',
					sortable: true,
				},
				{
					key: 'Containers::Container Name',
					label: 'Name',
					sortable: true,
				},
				{
					key: 'Containers::Pallet',
					label: 'Pallet',
					sortable: true,
				},
				{
					key: 'Containers::Container Type',
					label: 'Type',
					sortable: true,
				},
				{
					key: 'Containers::Net Weight',
					label: 'Net',
					sortable: true,
				},
				{
					key: 'Containers::Gross Weight',
					label: 'Gross',
					sortable: true
				},
				{
					key: 'Containers::Gross UoM',
					label: 'UoM',
					sortable: true
				},
				{
					key: 'CN_LI::Found Count',
					label: 'LI Ct',
					sortable: true
				},
				{
					key: 'move',
					label: ' '
				},
			],
			rowsPerPageOptions: [
				{
					value: 10,
					text: '10'
				},
				{
					value: 25,
					text: '25'
				},
				{
					value: 50,
					text: '50'
				},
				{
					value: 100,
					text: '100'
				},
			]
		}
	}
}
</script>
<style scoped>
html, body {
    min-height: 100%;
}

body {
    position: relative;
}

.add-container-button-wrapper {
    padding-top: 0.5em;
}

#job >>> .b-table tr th, #job >>> .b-table tr td {
    font-size: small;
}

#job >>> .b-table tr {
    white-space: nowrap;
}

#job >>> select.form-control {
    background-color: rgb(248, 248, 248);
}
</style>
<style>
.pic-slide {
    height: -moz-available; /* WebKit-based browsers will ignore this. */
    height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
}

.pic-slide img {
    max-height: 100%;
}

.my-modal-wrap {
    top: 75px !important;
    text-align: center;
}
</style>